module.exports = __webpack_public_path__ + "img/icon-info-gray.65d24552.svg";